export default __webpack_public_path__ + "static/nokia-logo-efcf2876871c2a995841f72cdd209f80.png";